import script from "./form-game.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-game.vue?vue&type=script&setup=true&lang=ts"

import "./form-game.vue?vue&type=style&index=0&id=76c7cffa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76c7cffa"]])

export default __exports__